import { atom } from 'recoil';

/**
 * The keys of the tasks running in the app, such as the series UID of an
 * image being downloaded. One set for the whole app, so every control that
 * offers a task on the same item sees it running.
 */
export const runningTaskKeysState = atom<ReadonlySet<string>>({
    key: 'runningTaskKeysState',
    default: new Set<string>(),
});
